import React, { Component } from 'react';
import {Accordion, AccordionSummary, AccordionDetails, Button, Fade, Grid, Hidden, Modal, Radio, Switch, CircularProgress} from "@material-ui/core";
import { Form, Formik } from "formik";
import NotificationManager from "react-notifications/lib/NotificationManager";
import * as Yup from "yup";
import { connect } from "react-redux";
import { Close } from '@material-ui/icons';
import { client } from '../../config/apollo';
import { ADD_USER_PAYMENT } from "../../graphql/mutations/user";
import { GET_SUBSCRIPTION_PLANS, VALIDATE_COUPON, FETCH_LAST_SUBSCRIPTION } from "../../graphql/queries/chef";
import { CREATE_SUBSCRIPTION } from "../../graphql/mutations/chef";
import { getPaymentInfo } from "../../redux/user";
import InputField from "../../components/Field";
import DinerButton from '../../components/DinerButton';
import GetCardType from '../../utils/card-type';
import style from './style';
import ListItem from "@material-ui/core/ListItem";
import AddCard from "../../components/AddCard";

const amex = "/images/amex.webp";
const discover = "/images/discover.webp";
const dinersclub = "/images/dinersclub.webp";
const jcb = "/images/jcb.webp";
const mastercard = "/images/mastercard.webp";
const visa = "/images/visa.webp";
const unionpay = "/images/unionpay.png";
const othercc = "/images/cc-outline.png";

const expiryRegex = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
const VerifySchema = Yup.object().shape({
  cardNumber: Yup.string().required("card number is required"),
  expiry: Yup.string()
    .matches(expiryRegex, {
      message: "Incorrect format. Example MM/YY",
      excludeEmptyString: true
    })
    .required("expiry is required"),
  cvv: Yup.string()
    .min(3, "enter valid cvv")
    .max(4, "enter valid cvv")
    .required("cvv is required"),
  cardName: Yup.string()
});

class Subscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentInfo: this.props.paymentInfo ? this.props.paymentInfo : [],
      selectedSubscription: 'pro',
      discountCode: null,
      isMonthly: false,
      open: false,
      cardType: '',
      couponErr: false,
      couponErrMsg: '',
      selectedCard: null,
      selectedCardIndex: -1,
      subscriptionPlans: [],
      selectedSubscriptionPlan: null,
      lastSubscription: null,
      initialValues: {
        cardNumber: "",
        cardName: "",
        cvv: "",
        expiry: ""
      },
      isCardLoading: false,
      addingSubscription: false,
      showPro: false,
      showFlex: false,
      couponMonths: 0,
      showCVVErr: false
    };

    this.addCard = this.addCard.bind(this);
    this.addSubscription = this.addSubscription.bind(this);
    this.handlePlanChange = this.handlePlanChange.bind(this);
    this.setSubscriptionPlan = this.setSubscriptionPlan.bind(this);
    this.validateCoupon = this.validateCoupon.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.paymentInfo) {
      if (props.paymentInfo.length > 0) {
        return {
          selectedCardIndex: 0,
          selectedCard: props.paymentInfo[0].card.cardId
        };
      }
    }
    return null;
  }

  componentDidMount() {
    this.props.dispatch(getPaymentInfo(this.props.userId));
    client.query({
      query: GET_SUBSCRIPTION_PLANS,
      variables: {
        userId: this.props.userId
      }
    })
      .then(response => {
        if (!!response && !!response.data && !!response.data.productsList) {
          this.setState({ subscriptionPlans: response.data.productsList });
          this.handlePlanChange('pro');
        }
      })
      .catch(err => {
        console.log('ERROR SUBSCRIPTION PLANS: ', err);
      });

    client.query({
      query: FETCH_LAST_SUBSCRIPTION,
      variables: {
        chefId: this.props.userId
      },
      fetchPolicy: 'network-only'
    })
      .then(response => {
        const { data } = response;

        this.setState({
          lastSubscription: data.fetchSubscription
        });
      })
      .catch(err => {
        console.log('ERROR Chef Last subscription: ', err);
      });

    this.handlePlanChange('pro');
    this.setState({ showPro: true, showFlex: false });
  }

  handlePlanChange(planName) {
    switch (planName) {
      default:
        this.setState({ selectedSubscription: 'pro' });
        this.setSubscriptionPlan('pro');
        return;

      case 'pro':
        this.setState({ selectedSubscription: planName });
        this.setSubscriptionPlan(planName);
        return;

      case 'flex-pro':
        this.setState({ selectedSubscription: planName });
        this.setSubscriptionPlan(planName);
        return;
    }
  }

  setSubscriptionPlan(planName) {
    const { isMonthly, subscriptionPlans } = this.state;

    if (planName === 'pro') {
      const index = subscriptionPlans.findIndex(item => item.name.indexOf('Professional') > -1);

      if (index > -1) {
        const prices = subscriptionPlans[index].priceScheme;
        if (isMonthly) {
          if (prices[0].recurring.interval === 'month') {
            this.setState({ selectedSubscriptionPlan: prices[0].id });
          }

          if (prices.length > 1) {
            if (prices[1].recurring.interval === 'month') {
              this.setState({ selectedSubscriptionPlan: prices[1].id });
            }
          } // end-if prices length
        } // end-if isMonthly
        else {
          if (prices[0].recurring.interval === 'year') {
            this.setState({ selectedSubscriptionPlan: prices[0].id });
          }

          if (prices.length > 1) {
            if (prices[1].recurring.interval === 'year') {
              this.setState({ selectedSubscriptionPlan: prices[1].id });
            }
          } // end-if prices length
        } // end-else for monthly
      } // end-if plan index > -1
    } // end-if plan name === pro

    if (planName === 'flex-pro') {
      const index = subscriptionPlans.findIndex(item => item.name.indexOf('Flex') > -1);
      if (index > -1) {
        const prices = subscriptionPlans[index].priceScheme;

        if (isMonthly) {
          if (prices[0].recurring.interval === 'month') {
            this.setState({ selectedSubscriptionPlan: prices[0].id });
          }

          if (prices.length > 1) {
            if (prices[1].recurring.interval === 'month') {
              this.setState({ selectedSubscriptionPlan: prices[1].id });
            }
          } // end-if prices length
        } // end-if isMonthly
        else {
          if (prices[0].recurring.interval === 'year') {
            this.setState({ selectedSubscriptionPlan: prices[0].id });
          }

          if (prices.length > 1) {
            if (prices[1].recurring.interval === 'year') {
              this.setState({ selectedSubscriptionPlan: prices[1].id });
            }
          } // end-if prices length
        } // end-else for monthly
      } // end-if plan index > -1
    } // end-if plan name === pro
  }

  addCard(values) {
    this.setState({ isCardLoading: true });
    let {
      cardNumber, cardName,
      cvv, expiry
    } = values;

    cardNumber = cardNumber.replace(/-/g, '');
    const expiryArr = expiry.split('/');

    if (expiryArr.length < 1) {
      NotificationManager.error('Invalid expiry details', 'Add card');
      this.setState({ isCardLoading: false });
      return;
    }

    const thisMonth = (new Date().getMonth() + 1);
    const thisYear = new Date().getFullYear();

    if (parseInt('20' + expiryArr[1]) < thisYear || (expiryArr[0] < thisMonth && parseInt('20' + expiryArr[1]) < thisYear)) {
      NotificationManager.error('Invalid expiry details', 'Add card');
      this.setState({ isCardLoading: false });
      return;
    }

    if (cardNumber.length < 14 || cardNumber.length > 16 || cvv.length < 3 || cvv.length > 4) {
      NotificationManager.error('Invalid details. Please make sure you have entered the details in the right format.', 'Add card');
      this.setState({ isCardLoading: false });
      return;
    }

    if ((this.state.cardType.toLowerCase().startsWith('amex') || this.state.cardType.toLowerCase().startsWith('american')) && cvv.length !== 4) {
      NotificationManager.error('This is not a valid CVV number.', 'Add card');
      this.setState({ isCardLoading: false, showCVVErr: true });
      setTimeout(() => {
        this.setState({ showCVVErr: false });
      }, 5000);
      return;
    }

    if (!(this.state.cardType.toLowerCase().startsWith('amex') && !this.state.cardType.toLowerCase().startsWith('american')) && cvv.length !== 3) {
      NotificationManager.error('This is not a valid CVV number.', 'Add card');
      this.setState({ isCardLoading: false, showCVVErr: true });
      setTimeout(() => {
        this.setState({ showCVVErr: false });
      }, 5000);
      return;
    }

    const payload = {
      number: cardNumber,
      expMonth: expiryArr[0],
      expYear: expiryArr[1],
      cvc: cvv
    };

    if (cardName.length > 2) {
      payload.nameOnCard = cardName;
    }

    client.mutate({
        mutation: ADD_USER_PAYMENT,
        variables: {
          userId: this.props.userId,
          payment: {
            type: 'CARD',
            card: payload
          }
        }
      })
      .then(response => {
        this.props.dispatch(getPaymentInfo(this.props.userId));
        this.setState({ open: false, selectedCardIndex: 0, isCardLoading: false });
      })
      .catch(err => {
        this.setState({ isCardLoading: false });
        let errorObj = JSON.parse(JSON.stringify(err));
        if (errorObj.graphQLErrors) {
          errorObj.graphQLErrors.map(error => {
            NotificationManager.error(error.message, "Add card");
          });
        }
      });
  }

  addSubscription() {
    this.setState({ addingSubscription: true });
    const {
      selectedCard,
      selectedCardIndex,
      selectedSubscriptionPlan,
      discountCode,
      couponErr
    } = this.state;

    if (couponErr) {
      NotificationManager.error('Invalid coupon. Please remove coupon code to proceed without the same.', 'Coupon');
      this.setState({ addingSubscription: false });
      return;
    }

    if (selectedCard && selectedCardIndex > -1 && !!selectedSubscriptionPlan) {
      const payload = {
        id: this.props.userId,
        cardId: selectedCard,
        priceId: selectedSubscriptionPlan
      };

      if (!!discountCode) {
        if (discountCode.trim().length > 0) {
          payload.discountCode = discountCode;
        }
      }

      client
        .mutate({
          mutation: CREATE_SUBSCRIPTION,
          variables: payload
        })
        .then(response => {
          this.setState({ addingSubscription: false });
          this.props.onSuccess();
        })
        .catch(err => {
          this.setState({ addingSubscription: false });
        });
    } else {
      this.setState({ addingSubscription: false });
      NotificationManager.error('Please choose a card to add for subscription', 'Add subscription');
      return;
    }
  };

  validateCoupon() {
    const {discountCode} = this.state;

    if (!!discountCode && !!discountCode.length && discountCode.trim().length > 0) {
      client.query({
        query: VALIDATE_COUPON,
        variables: {
          coupon: discountCode
        }
      }).then(response => {
        if (response.data.validateCoupon) {
          this.setState({
            couponErr: false,
            couponErrMsg: response.data.validateCoupon.name,
            couponMonths: response.data.validateCoupon.monthCount
          });
        } else {
          NotificationManager.error("Invalid coupon", "Coupon")
          this.setState({
            couponErr: true,
            couponErrMsg: '',
          });
        }
      })
        .catch(err => {
          console.log('VALIDATION ERR: ', err);
        });
    } else {
      this.setState({
        discountCode: null,
        couponErr: false,
        couponErrMsg: '',
      });
    }
  }

  render () {
    const { isMonthly, selectedSubscription, lastSubscription } = this.state;

    if (lastSubscription) {
      return (
        <div className="chef-right-col">
          <p style={style.headerText}>You have already subscribed to <span
            style={{color: '#ff8000'}}>{lastSubscription.name}</span> for {lastSubscription.duration} {lastSubscription.price < 100 ? 'month' : 'year'}.</p>
          <Grid container alignItems={"flex-end"} justify={"flex-end"}>
            <Button
              onClick={this.props.onSuccess}
              style={style.subscribeButton}>
              Continue
            </Button>
          </Grid>
        </div>
      );
    }


    return (
      <div className="chef-right-col">
        <div className="schedule-head-col">
          <div className="header-step-col">
            <p className="located-text" style={style.headerText}>
              Please choose your subscription plan.
            </p>
            <div className="cont-btn">
              <DinerButton />
            </div>
          </div>
        </div>

        <Grid container alignContent={'flex-end'} justify={'flex-end'} style={{ marginBottom: 20, paddingRight: 0 }}>

          <Switch data-test-id={"annswitch-id"} checked={isMonthly} onChange={(ev) => {
            this.setState({ isMonthly: !this.state.isMonthly }, () => {
              this.setSubscriptionPlan(this.state.selectedSubscription);
            });
          } } />
          <span style={isMonthly ? style.monthlyText : style.yearlyText}>{isMonthly ? 'Monthly' : 'Annual'}</span>
        </Grid>

        <Grid container className="table-container">
          <Hidden xsDown>
            <>
              <Grid data-test-id={"proplan-id"} item xs={12} sm={6} style={selectedSubscription === 'pro' ? style.selectedSubContainer : style.subContainer} onClick={() => this.handlePlanChange('pro')}>

                <Grid
                  style={selectedSubscription === 'pro' ? {borderTopLeftRadius: 9, ...style.subPriceContainerSelected} : {borderTopLeftRadius: 9, ...style.subPriceContainer}}>
                  <p data-test-id={"proplanyr-id"} style={style.planName}>Pro plan</p>
                  <p data-test-id={"proplanmon-id"} style={style.additionalText}>{isMonthly ? 'Save $198 with annual plan' : ''}</p>
                </Grid>
                <Grid style={style.evenRow}>
                  <p style={selectedSubscription === 'pro' ? style.evenRowTextSelected : style.evenRowText}>
                    <span style={style.planDescHeads}>Listing fee</span><br />
                    {isMonthly ? '$99' : '$999'}
                  </p>
                </Grid>
                <Grid style={style.oddRow}>
                  <p style={selectedSubscription === 'pro' ? style.oddRowTextSelected : style.oddRowText}>
                    <span style={style.planDescHeads}>Verified chef</span><br />
                    {!isMonthly ? 'Included' : 'Not included'}<br />
                    <span>{!isMonthly ? '($50 savings)' : '($50 extra)'}</span>
                  </p>
                </Grid>
                <Grid style={style.evenRow}>
                  <p style={selectedSubscription === 'pro' ? style.evenRowTextSelected : style.evenRowText}>
                    <span style={style.planDescHeads}>Transaction fee</span><br />
                    5% of booking value
                  </p>
                </Grid>
                <Grid style={{...style.oddRow, borderBottomLeftRadius: 10}}>
                  <p style={selectedSubscription === 'pro' ? style.oddRowTextSelected : style.oddRowText}>
                    <span style={style.planDescHeads}>Featured chef</span><br />
                    More often
                  </p>
                </Grid>
              </Grid>

              <Grid data-test-id={"flexpro-id"} item xs={12} sm={6} style={selectedSubscription === 'flex-pro' ? style.selectedSubContainer : style.subContainer} onClick={() => this.handlePlanChange('flex-pro')}>
            <Grid className="ipad-column" style={selectedSubscription === 'flex-pro' ? {borderTopRightRadius: 9, ...style.subPriceContainerSelected} : {borderTopRightRadius: 9, ...style.subPriceContainer}}>
              <p data-test-id={"flexproyr-id"} style={style.planName}>Flex plan</p>
              <p data-test-id={"flexpromon-id"} style={style.additionalText}>{isMonthly ? 'Save $78 with annual plan' : ''}</p>
            </Grid>
            <Grid style={style.evenRow}>
              <p style={selectedSubscription === 'flex-pro' ? style.evenRowTextSelected : style.evenRowText}>
                <span style={style.planDescHeads}>Listing fee</span><br />
                {isMonthly ? '$39' : '$399'}
              </p>
            </Grid>
            <Grid style={style.oddRow}>
              <p style={selectedSubscription === 'flex-pro' ? style.oddRowTextSelected : style.oddRowText}>
                <span style={style.planDescHeads}>Verified chef</span><br />
                Not included<br />
                <span>{isMonthly ? '($50 extra)' : '($50 extra)'}</span>
              </p>
            </Grid>
            <Grid style={style.evenRow}>
              <p style={selectedSubscription === 'flex-pro' ? style.evenRowTextSelected : style.evenRowText}>
                <span style={style.planDescHeads}>Transaction fee</span><br />
                15% of booking value
              </p>
            </Grid>
            <Grid style={{...style.oddRow, borderBottomRightRadius: 10}}>
              <p style={selectedSubscription === 'flex-pro' ? style.oddRowTextSelected : style.oddRowText}>
                <span style={style.planDescHeads}>Featured chef</span><br />
                Less often
              </p>
            </Grid>
          </Grid>
            </>
          </Hidden>

          <Hidden smUp>

            <Grid data-test-id={"proplan-id"} item xs={12} sm={6} style={selectedSubscription === 'pro' ? style.selectedSubContainerMobile : style.subContainer} onClick={() => {
              this.handlePlanChange('pro');
              this.setState({ showPro: true, showFlex: false });
            }}>

              <Grid
                style={selectedSubscription === 'pro' ? {...style.subPriceContainerSelectedMobile} : {...style.subPriceContainerMobile}}>
                <p data-test-id={"proplanyr-id"} style={style.planName}>Pro plan</p>
                <p data-test-id={"proplanmon-id"} style={style.additionalText}>{isMonthly ? 'Save $198 with annual plan' : ''}</p>
              </Grid>
              {this.state.showPro && (
                <>
                  <Grid style={style.evenRow}>
                    <p style={selectedSubscription === 'pro' ? style.evenRowTextSelected : style.evenRowText}>
                      <span style={style.planDescHeads}>Listing fee</span><br />
                      {isMonthly ? '$99' : '$999'}
                    </p>
                  </Grid>
                  <Grid style={style.oddRow}>
                    <p style={selectedSubscription === 'pro' ? style.oddRowTextSelected : style.oddRowText}>
                      <span style={style.planDescHeads}>Verified chef</span><br />
                      {!isMonthly ? 'Included' : 'Not included'}<br />
                      <span>{!isMonthly ? '($50 savings)' : '($50 extra)'}</span>
                    </p>
                  </Grid>
                  <Grid style={style.evenRow}>
                    <p style={selectedSubscription === 'pro' ? style.evenRowTextSelected : style.evenRowText}>
                      <span style={style.planDescHeads}>Transaction fee</span><br />
                      5% of booking value
                    </p>
                  </Grid>
                  <Grid style={{...style.oddRow, borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>
                    <p style={selectedSubscription === 'pro' ? style.oddRowTextSelected : style.oddRowText}>
                      <span style={style.planDescHeads}>Featured chef</span><br />
                      More often
                    </p>
                  </Grid>
                </>
              )}
            </Grid>

            <Grid data-test-id={"flexpro-id"} item xs={12} sm={6} style={selectedSubscription === 'flex-pro' ? {...style.selectedSubContainerMobile, marginTop: 15} : style.subContainer} onClick={() => {
              this.handlePlanChange('flex-pro');
              this.setState({ showFlex: true, showPro: false });
            }}>
              <Grid className="ipad-column" style={selectedSubscription === 'flex-pro' ? style.subPriceContainerSelectedMobile : {marginTop: 15, ...style.subPriceContainerMobile}}>
                <p data-test-id={"flexproyr-id"} style={style.planName}>Flex plan</p>
                <p data-test-id={"flexpromon-id"} style={style.additionalText}>{isMonthly ? 'Save $78 with annual plan' : ''}</p>
              </Grid>
              {this.state.showFlex && (
                <>
                  <Grid style={style.evenRow}>
                    <p style={selectedSubscription === 'flex-pro' ? style.evenRowTextSelected : style.evenRowText}>
                      <span style={style.planDescHeads}>Listing fee</span><br />
                      {isMonthly ? '$39' : '$399'}
                    </p>
                  </Grid>
                  <Grid style={style.oddRow}>
                    <p style={selectedSubscription === 'flex-pro' ? style.oddRowTextSelected : style.oddRowText}>
                      <span style={style.planDescHeads}>Verified chef</span><br />
                      Not included<br />
                      <span>($50 extra)</span>
                    </p>
                  </Grid>
                  <Grid style={style.evenRow}>
                    <p style={selectedSubscription === 'flex-pro' ? style.evenRowTextSelected : style.evenRowText}>
                      <span style={style.planDescHeads}>Transaction fee</span><br />
                      15% of booking value
                    </p>
                  </Grid>
                  <Grid style={{...style.oddRow, borderBottomLeftRadius: 10, borderBottomRightRadius: 10}}>
                    <p style={selectedSubscription === 'flex-pro' ? style.oddRowTextSelected : style.oddRowText}>
                      <span style={style.planDescHeads}>Featured chef</span><br />
                      Less often
                    </p>
                  </Grid>
                </>
              )}
            </Grid>
          </Hidden>

          <AddCard show={this.state.open} close={() => this.setState({ open: false })} onSuccess={() => {}} />
        </Grid>

        <Grid className="ipad-view" container style={{ marginTop: 30 }}>
          <Grid item xs={12}>
            <Grid data-test-id={"disc-id"} className="ipad-justify mbl-coupan" container justify={'flex-end'} alignItems={'flex-end'}>
              <input
                name={"discountCode"}
                placeholder={"Coupon code"}
                type={"text"}
                onChange={evt => this.setState({ discountCode: evt.target.value })}
                onBlur={() => this.validateCoupon()}
                value={this.state.discountCode}
                style={{
                  width: 150,
                  border: 'none',
                  borderBottom: '1px solid #ff8000',
                  fontSize: 18,
                  font: 'Poppins',
                  margin: '6px 0 20px 30px',
                  outline: 'none'
                }}
              />
            </Grid>

            <Grid container justify={'flex-end'} alignItems={'flex-end'} style={{marginBottom: 20}}>
              <span style={this.state.couponErr ? {color: 'red', fontSize: 16} : {color: 'green', fontSize: 16}}>
                {this.state.couponErrMsg}
              </span>
              {this.state.couponErrMsg && !this.state.couponErr && (
                <span style={{color: '#ff8000', fontSize: 14, marginTop: 20}}>
                  The terms of this subscription ({this.state.couponErrMsg}) and transaction fee of 15% per booking apply during the coupon period ({this.state.couponMonths} {parseInt(this.state.couponMonths) > 1 ? 'months' : 'month'}),
                   after which the subscription renewal fee and the transaction fee charged per booking will be as per the plan chosen above.
                </span>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid container className="bottom-sub-col" style={{justifyContent: 'flex-end'}}>
        {(this.props.paymentInfo && this.props.paymentInfo.length > 0) && <Grid className="card-column-sub" item xs={12} md={6}>
            {this.props.paymentInfo.map((payment, index) => {
              return (
                <ListItem
                  style={{ display: "flex", padding: 0 }}
                >
                  <div>
                    <Radio color="primary" checked={this.state.selectedCardIndex === index} onChange={() => this.setState({ selectedCard: payment.card.cardId, selectedCardIndex: index })} />
                  </div>
                  <div>
                    <p>
                      ************{payment.card.last4}
                    </p>
                  </div>
                  <div>
                    <img src={payment.card.type.toLowerCase().startsWith('visa') ? visa : (
                      payment.card.type.toLowerCase().startsWith('master') ? mastercard : (
                        payment.card.type.toLowerCase().startsWith('american') || payment.card.type.toLowerCase().startsWith('amex') ? amex : (
                          payment.card.type.toLowerCase().startsWith('disco') ? discover : (
                            payment.card.type.toLowerCase().startsWith('diner') ? dinersclub : (
                              payment.card.type.toLowerCase().startsWith('jc') ? jcb : unionpay
                            )
                          )
                        )
                      )
                    )} style={style.cardImgInput} />
                  </div>

                </ListItem>
              );
            })}
          </Grid>}

          {this.state.addingSubscription ? (
            <CircularProgress color={"#ff8000"} />
          ) : (
            <Grid className="add-card-subscription mbl-sub-col" item xs={12} md={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
              <Button  data-test-id={"addcard-id"}  onClick={() => this.setState({ open: true, cardType: "" })} style={{ ...style.subscribeButton, marginRight: 10 }}>

                Add card
              </Button>

              <Button
                data-test-id={"subscribe-id"}
                id={"subscribe-submit"}
                disabled={!this.state.selectedCard || this.state.addingSubscription}
                onClick={() => {
                  document.getElementById('subscribe-submit').disabled = true;
                  this.addSubscription();
                }}
                style={this.state.selectedCard ? style.subscribeButton : style.subscribeButtonDisabled}>
                Subscribe
              </Button>
            </Grid>
          )}

        </Grid>
      </div>
    );
  }
}

const mapSateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    diner: state.user.diner,
    chef: state.user.chef,
    paymentInfo: state.user.paymentInfo
  };
};

const SubscriptionPage = connect(mapSateToProps)(Subscription);

export default SubscriptionPage;
